import { readCookieConsent } from './cookie-consent';

const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID?.trim();
const CLARITY_SCRIPT_ID = 'eplotera-microsoft-clarity';

type ClarityCommand = [string, ...unknown[]];
type ClarityQueue = ((...command: ClarityCommand) => void) & { q: ClarityCommand[] };

declare global {
  interface Window {
    clarity?: ClarityQueue;
  }
}

let clarityInitialized = false;

export function initializeMicrosoftClarity(): boolean {
  if (!projectId || !/^[a-z0-9]{6,20}$/i.test(projectId) || readCookieConsent() !== 'accepted') return false;
  if (clarityInitialized) return true;

  const queue = ((...command: ClarityCommand) => {
    queue.q.push(command);
  }) as ClarityQueue;
  queue.q = [];
  window.clarity = queue;
  queue('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });

  const script = document.createElement('script');
  script.id = CLARITY_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  document.head.appendChild(script);
  clarityInitialized = true;
  return true;
}

export function disableMicrosoftClarity(): boolean {
  for (const entry of document.cookie.split(';')) {
    const name = entry.trim().split('=')[0];
    if (name !== '_clck' && name !== '_clsk') continue;
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    if (window.location.hostname === 'eplotera.com' || window.location.hostname.endsWith('.eplotera.com')) {
      document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax; Domain=.eplotera.com`;
    }
  }
  if (!clarityInitialized) return false;
  window.clarity?.('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' });
  return true;
}
